import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import cognito from "./cognito";
import authenticater from "./authenticater";
import axios from "axios";
import { initMenu, initComponent } from "./utils/menus";

import { postRequest } from "./utils/api";
import { postKeyValueRequest } from "./utils/api";
import { putRequest } from "./utils/api";
import { deleteRequest } from "./utils/api";
import { getRequest } from "./utils/api";
import { getStreamRequest } from "./utils/api";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import moment from "moment";

import "@mdi/font/css/materialdesignicons.css";

import $ from "jquery";
Vue.prototype.$ = $;

Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.getStreamRequest = getStreamRequest;

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.use(VueToast, {
  position: "top",
  duration: 5000,
});

Vue.filter("dateString", function (value, format = "YYYY/MM/DD") {
  if (value) {
    return moment(value).format(format);
  } else {
    return "";
  }
});

Vue.filter("numberString", function (value) {
  if (value) {
    return new Intl.NumberFormat("ja-JP").format(value);
  } else {
    return "";
  }
});

let GlobalData = new Vue({
  data: {
    $useCognito: false, //cognitoによる認証機能
    $useMailDelivery: false, //お知らせメール配信機能
    $useBulletinBoard: false, //掲示板機能
    $uploadFileSize: 0, //お知らせファイルアップロードサイズ上限
    $useRoomAddition: false, //部屋追加機能
    $cardType: false, //入退カード種類（true:Felica  false:EM2）
    $mealCollectiveEndMonth: 0, //食事一括登録可能範囲
    $visitorCardIssua: false, // カード発行機能（false:機能なし。true:機能あり）
    $useCalcMagnification: false, //M01による倍率計算機能
    $useUpdateEnergyInput: false, //エネルギー入力画面での、更新・削除・登録機能
    $useWithoutEat: false, //喫食機能
    $dmsUseFlg: false, //部屋利用フラグ
    $carUseFlg: false, //車両利用フラグ
    $mealUseFlg: false, //食事利用フラグ
    $gasUseFlg: false, //ガス利用フラグ
    $elUseFlg: false, //電気利用フラグ
    $waUseFlg: false, //水道利用フラグ
    $ocUseFlg: false, //その他課金利用フラグ
    $neiUseFlg: false, //自治会費利用フラグ
  },
});

// 単項目チェックルール
Vue.mixin({
  data() {
    return {
      GlobalRules: {
        //ファイルサイズチェック
        fileSize_2MB: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.size <= this.$getUploadFileSize()) ||
            "ファイルサイズが上限を超えています。"
          );
        },
        //半角スペース
        space_check: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /[\s]/;
          return !pattern.test(value.name) || "スペースを含めないでください。";
        },
        // 必須チェック
        required: (value) => !!value || "必須入力です。",
        // 桁数チェック
        counter_1: (value) => {
          if (!value) {
            return true;
          }
          return (value && value.length <= 1) || "1桁で入力してください。";
        },
        counter_2: (value) => {
          if (!value) {
            return true;
          }
          return (value && value.length <= 2) || "2桁以内で入力してください。";
        },
        counter_4: (value) => {
          if (!value) {
            return true;
          }
          return (value && value.length <= 4) || "4桁以内で入力してください。";
        },
        counter_5: (value) => {
          if (!value) {
            return true;
          }
          return (value && value.length <= 5) || "5桁以内で入力してください。";
        },
        counter_10: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 10) || "10桁以内で入力してください。"
          );
        },
        counter_13: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 13) || "13桁以内で入力してください。"
          );
        },
        counter_15: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 15) || "15桁以内で入力してください。"
          );
        },
        counter_20: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 20) || "20桁以内で入力してください。"
          );
        },
        counter_30: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 30) || "30桁以内で入力してください。"
          );
        },
        counter_50: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 50) || "50桁以内で入力してください。"
          );
        },
        counter_64: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 64) || "64桁以内で入力してください。"
          );
        },
        counter_128: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length <= 128) || "128桁以内で入力してください。"
          );
        },
        more_8: (value) => {
          if (!value) {
            return true;
          }
          return (value && value.length >= 8) || "8桁以上で入力してください。";
        },
        // eMailアドレス形式チェック
        email: (value) => {
          if (!value) {
            return true;
          }
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return (
            pattern.test(value) || "メールアドレス形式で入力してください。"
          );
        },
        //認証コードチェック
        authcode: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]{6}\d*|0)$/;
          return pattern.test(value) || "認証コードを入力してください。";
        },
        //社員番号チェック
        employee_id: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]\d*|0)$/;
          return pattern.test(value) || "ユーザIDを入力してください。";
        },
        //パスワード形式チェック
        hanSpec: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z_?!#$%&]*$/;
          return pattern.test(value) || "使用できない文字です。";
        },
        required_lowercase: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[a-z])/;
          return pattern.test(value) || "小文字を含めてください。";
        },
        required_uppercase: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[A-Z])/;
          return pattern.test(value) || "大文字を含めてください。";
        },
        required_number: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[0-9])/;
          return pattern.test(value) || "数字を含めてください。";
        },
        required_spec: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^(?=.*[_?!#$%&])/;
          return pattern.test(value) || "特殊文字を含めてください。";
        },
        // 半角チェック
        hannkaku: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z\\+\\-\\/\\*\\,\\.]*$/;
          return pattern.test(value) || "半角文字のみで入力してください。";
        },
        // 半角カナ
        hanKana: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[ｦ-ﾟ ]*$/;
          return pattern.test(value) || "半角カナのみで入力してください。";
        },
        // 半角英数チェック
        hanAlpha: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z]*$/;
          return pattern.test(value) || "半角英数字のみで入力してください。";
        },
        // 2024.10.10 kouta_noborisaka 半角英数とハイフンのチェック start
        // 半角英数記号(‐のみ）チェック
        hanAlphahyphen: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[0-9a-zA-Z\\-]*$/;
          return (
            pattern.test(value) ||
            "半角英数字とハイフン（‐）のみで入力してください。"
          );
        },
        // 2024.10.10 kouta_noborisaka 半角英数とハイフンのチェック end
        // 整数数値チェック
        integer: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^[+,-]?\d*$/;
          return pattern.test(value) || "整数のみで入力してください。";
        },
        // 整数数値チェック（MIN、MAX)
        integerMax99: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value <= 99) || "99以下の整数数値で入力してください。"
          );
        },
        integerMin99: (value) => {
          if (!value) {
            return true;
          }
          return (value && value >= 0) || "0以上の整数数値で入力してください。";
        },
        // 数値チェック
        number: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^-?([1-9][0-9]*|0)(\.[0-9]+)?$/;
          return pattern.test(value) || "数値のみで入力してください。";
        },
        // 電話番号
        number2: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]*)(-[0-9]+)?(-[0-9]+)?$/;
          return pattern.test(value) || "電話番号で入力してください。";
        },
        // 数値チェック
        number3: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([0-9]*|0)$/;
          return pattern.test(value) || "数値のみで入力してください。";
        },
        // 数値チェック
        number4: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value.length >= 4) || "4桁の整数数値で入力してください。"
          );
        },
        // 数値チェック（MIN、MAX)
        numberMax99: (value) => {
          if (!value) {
            return true;
          }
          return (value && value <= 99.9) || "99以下の数値で入力してください。";
        },
        numberMax100: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 100) || "99.99以下の数値で入力してください。"
          );
        },
        numberMax100_point_999: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 100) || "99.999以下の数値で入力してください。"
          );
        },
        numberMax10000000_point_999: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 100000000) ||
            "99999999.999以下の数値で入力してください。"
          );
        },
        numberMax100000000_point_999: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 1000000000) ||
            "999999999.999以下の数値で入力してください。"
          );
        },
        numberMax100000_point_999: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 1000000) ||
            "999999.999以下の数値で入力してください。"
          );
        },
        numberMax10000: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 10000) || "9999.99以下の数値で入力してください。"
          );
        },
        numberMax1000: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value < 1000) || "999.99以下の数値で入力してください。"
          );
        },
        numberMin99: (value) => {
          if (!value) {
            return true;
          }
          return (value && value >= 0) || "0以上の数値で入力してください。";
        },
        numberMin1: (value) => {
          if (!value) {
            return true;
          }
          return (value && value >= 1) || "1以上の数値で入力してください。";
        },
        // 金額チェック
        currency: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([1-9]\d*|0)$/;
          return pattern.test(value) || "整数で入力してください。";
        },
        number_point_2: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^((?!0[0-9])\d+(\.\d{1,2})?)$/;
          return (
            pattern.test(value) ||
            "整数または小数点以下の二桁で入力してください。"
          );
        },
        number_point_3: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^((?!0[0-9])\d+(\.\d{1,3})?)$/;
          return (
            pattern.test(value) ||
            "整数または小数点以下の三桁で入力してください。"
          );
        },
        number_point_4: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^((?!0[0-9])\d+(\.\d{1,4})?)$/;
          return (
            pattern.test(value) ||
            "整数または小数点以下の四桁で入力してください。"
          );
        },
        // 階数チェック
        numbercuurency: (value) => {
          if (!value) {
            return true;
          }
          const pattern = /^([1-9]\d*|0)$/;
          return pattern.test(value) || "1以上の数値で入力してください。";
        },
        //数値チェック（メータ値）
        meterVal: (value) => {
          const pattern = /^([1-9][0-9]{0,5}|0)(\.[0-9]{0,3})?$/;
          return (
            pattern.test(value) ||
            "整数部６桁以下、小数部３桁以下で入力してください。"
          );
        },
        //数値チェック（使用量）
        useAmount: (value) => {
          const pattern = /^([1-9][0-9]{0,6}|0)(\.[0-9]{0,3})?$/;
          return (
            pattern.test(value) ||
            "整数部7桁以下、小数部３桁以下で入力してください。"
          );
        },
        // 外字チェック（特殊文字禁止）
        spec: (value) => {
          if (!value) {
            return true;
          }
          var iChars = '~`!#$%^&*+=-[]\\;,/{}|":<>?';
          var checkFlag = false;
          for (var i = 0; i < value.length; i++) {
            if (iChars.indexOf(value.charAt(i)) != -1) {
              checkFlag = true;
              break;
            }
          }
          return !checkFlag || "特殊文字禁止が含まれています。";
        },
        // 整数数値チェック（MIN、MAX)
        integerMax30: (value) => {
          if (!value) {
            return true;
          }
          return (
            (value && value <= 30) || "３０以下の整数数値で入力してください。"
          );
        },        
      },
    };
  },
  methods: {
    //script内からグローバル変数にアクセス
    $getUseMailDelivery() {
      return GlobalData.$data.$useMailDelivery;
    },
    $setUseMailDelivery(val) {
      GlobalData.$data.$useMailDelivery = val;
    },
    $getUseCognito() {
      return GlobalData.$data.$useCognito;
    },
    $setUseCognito(val) {
      GlobalData.$data.$useCognito = val;
    },
    $getUseBulletinBoard() {
      return GlobalData.$data.$useBulletinBoard;
    },
    $getCardType() {
      return GlobalData.$data.$cardType;
    },
    $getMealCollectiveEndMonth() {
      return GlobalData.$data.$mealCollectiveEndMonth;
    },
    $setUseBulletinBoard(val) {
      GlobalData.$data.$useBulletinBoard = val;
    },
    $getUploadFileSize() {
      return GlobalData.$data.$uploadFileSize_b;
    },
    $setUploadFileSize(val) {
      GlobalData.$data.$uploadFileSize_b = val;
    },
    $getUseRoomAddition() {
      return GlobalData.$data.$useRoomAddition;
    },
    $setUseRoomAddition(val) {
      GlobalData.$data.$useRoomAddition = val;
    },
    $setCardType(val) {
      GlobalData.$data.$cardType = val;
    },
    $setMealCollectiveEndMonth(val) {
      GlobalData.$data.$mealCollectiveEndMonth = val;
    },
    $getVisitorCardIssua() {
      return GlobalData.$data.visitorCardIssua;
    },
    $setVisitorCardIssua(val) {
      GlobalData.$data.visitorCardIssua = val;
    },
    $getUseCalcMagnification() {
      return GlobalData.$data.$useCalcMagnification;
    },
    $setUseCalcMagnification(val) {
      GlobalData.$data.$useCalcMagnification = val;
    },
    $getUseUpdateEnergyInput() {
      return GlobalData.$data.$useUpdateEnergyInput;
    },
    $setUseUpdateEnergyInput(val) {
      GlobalData.$data.$useUpdateEnergyInput = val;
    },
    $getUseWithoutEat() {
      return GlobalData.$data.$useWithoutEat;
    },
    $setUseWithoutEat(val) {
      GlobalData.$data.$useWithoutEat = val;
    },
    $getDmsUseFlg() {
      return GlobalData.$data.$dmsUseFlg;
    },
    $setDmsUseFlg(val) {
      GlobalData.$data.$dmsUseFlg = val;
    },
    $getCarUseFlg() {
      return GlobalData.$data.$carUseFlg;
    },
    $setCarUseFlg(val) {
      GlobalData.$data.$carUseFlg = val;
    },
    $getMealUseFlg() {
      return GlobalData.$data.$mealUseFlg;
    },
    $setMealUseFlg(val) {
      GlobalData.$data.$mealUseFlg = val;
    },
    $getGasUseFlg() {
      return GlobalData.$data.$gasUseFlg;
    },
    $setGasUseFlg(val) {
      GlobalData.$data.$gasUseFlg = val;
    },
    $getElUseFlg() {
      return GlobalData.$data.$elUseFlg;
    },
    $setElUseFlg(val) {
      GlobalData.$data.$elUseFlg = val;
    },
    $getWaUseFlg() {
      return GlobalData.$data.$waUseFlg;
    },
    $setWaUseFlg(val) {
      GlobalData.$data.$waUseFlg = val;
    },
    $getOcUseFlg() {
      return GlobalData.$data.$ocUseFlg;
    },
    $setOcUseFlg(val) {
      GlobalData.$data.$ocUseFlg = val;
    },
    $getNeiUseFlg() {
      return GlobalData.$data.$neiUseFlg;
    },
    $setNeiUseFlg(val) {
      GlobalData.$data.$neiUseFlg = val;
    },
  },
  computed: {
    //template内からグローバル変数にアクセス
    $useMailDelivery: {
      get: function () {
        return GlobalData.$data.$useMailDelivery;
      },
    },
    $useCognito: {
      get: function () {
        return GlobalData.$data.$useCognito;
      },
    },
    $useBulletinBoard: {
      get: function () {
        return GlobalData.$data.$useBulletinBoard;
      },
    },
    $uploadFileSize: {
      get: function () {
        return GlobalData.$data.$uploadFileSize_b;
      },
    },
    $useRoomAddition: {
      get: function () {
        return GlobalData.$data.$useRoomAddition;
      },
    },
    $cardType: {
      get: function () {
        return GlobalData.$data.$cardType;
      },
    },
    $mealCollectiveEndMonth: {
      get: function () {
        return GlobalData.$data.$mealCollectiveEndMonth;
      },
    },
    $visitorCardIssua: {
      get: function () {
        return GlobalData.$data.$visitorCardIssua;
      },
    },
    $useCalcMagnification: {
      get: function () {
        return GlobalData.$data.$useCalcMagnification;
      },
    },
    $useUpdateEnergyInput: {
      get: function () {
        return GlobalData.$data.$useUpdateEnergyInput;
      },
    },
    $useWithoutEat: {
      get: function () {
        return GlobalData.$data.$useWithoutEat;
      },
    },
    $dmsUseFlg: {
      get: function () {
        return GlobalData.$data.$dmsUseFlg;
      },
    },
    $carUseFlg: {
      get: function () {
        return GlobalData.$data.$carUseFlg;
      },
    },
    $mealUseFlg: {
      get: function () {
        return GlobalData.$data.$mealUseFlg;
      },
    },
    $gasUseFlg: {
      get: function () {
        return GlobalData.$data.$gasUseFlg;
      },
    },
    $elUseFlg: {
      get: function () {
        return GlobalData.$data.$elUseFlg;
      },
    },
    $waUseFlg: {
      get: function () {
        return GlobalData.$data.$waUseFlg;
      },
    },
    $ocUseFlg: {
      get: function () {
        return GlobalData.$data.$ocUseFlg;
      },
    },
    $neiUseFlg: {
      get: function () {
        return GlobalData.$data.$neiUseFlg;
      },
    },
  },
});

//認証情報の有無によるルート制御
router.beforeEach(async (to, from, next) => {
  //【cognito】
  if (GlobalData.$data.$useCognito) {
    cognito
      .isAuthenticated()
      .then(async (session) => {
        //eslint-disable-line
        await initMenu(router, store);
        if (
          to.matched.some((record) => record.meta.notRequiredAuth) ||
          to.matched.some((record) => record.meta.requiredAuth)
        ) {
          next({
            //path: '/home',
            path: initComponent,
          });
        }
      })
      .catch((error) => {
        //eslint-disable-line
        if (to.matched.some((record) => record.meta.requiredAuth)) {
          // console.log(error);
          next({
            path: "/",
            query: { redirect: to.fullPath },
          });
        }
      });
    next();
  } else {
    if (to.matched.some((record) => record.meta.requiredAuth)) {
      await initMenu(router, store);
      next({
        path: initComponent,
      });
    } else {
      next();
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  cognito,
  authenticater,
  render: (h) => h(App),
}).$mount("#app");
